import * as React from 'react';
import { Checkbox, message, Tooltip, Button } from 'antd';
import { withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';

import DataTable, {
    DataTableColumnProps,
    Renderer,
    Filterer,
    DataTableButton,
    DataTableButtonReset
} from 'src/components/common/DataTable';

import TableRequestDTO from 'src/models/datatable/TableRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import StatementApiController from 'src/api/StatementApiController';
import StudentStatementDTO from 'src/models/statement/StudentStatementDTO';
import ViewStatementModal from 'src/components/admin/ViewStatementModal';

interface RouteParams {
    classroomId: string;
    userId: string;
}

// Note: RouteComponentProps<{}> MUST be removed if sub-component OR MUST return 'withRouter(ListUsers)'
interface StudentStatementsProps extends PageProps<RouteParams>, LocalizeContextProps {
}

interface StudentStatementsState {
    loading: boolean;
    tableRecords: StudentStatementDTO[];
    currentStudentId: number;
    classroomId: number;
    selectedStatement: StudentStatementDTO;
}

class StudentStatements extends React.Component<StudentStatementsProps, StudentStatementsState> {
    private dataTableRef: DataTable<StudentStatementDTO>;

    constructor(props: StudentStatementsProps) {
        super(props);
        bindAllOfThis(this, StudentStatements.prototype);

        let userId = parseInt(this.props.match.params.userId, 10);
        let classroomId = parseInt(this.props.match.params.classroomId, 10) || 0;

        this.state = {
            tableRecords: [],
            loading: true,
            currentStudentId: userId,
            classroomId: classroomId,
            selectedStatement: null,
        };
    }

    private updateStudentStatement(statementId: number, gradeId: number): void {
        StatementApiController.adminUpdateStudentStatementCompletion(statementId, this.state.currentStudentId, gradeId)
            .then(result => {
                message.success(this.props.translate('admin.studentStatements.messageUpdate'));
                this.dataTableRef.refresh();
            });
    }

    private fetchData(requestState: TableRequestDTO, checkEcho: () => boolean, callback: (response: TableResponseDTO<StudentStatementDTO>) => void): void {
        this.setState({ loading: true });

        StatementApiController.getStudentStatementTableData(requestState, this.state.currentStudentId)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                let tableRecords = results.data.results.length > 0 ? results.data.results : [];
                this.setState({
                    tableRecords: tableRecords,
                    loading: false
                });

                console.log(tableRecords);
                callback(results.data);
            });
    }

    private openNotesModal(record: StudentStatementDTO) {
        this.setState({ selectedStatement: record });
    }

    private closeNotesModal() {
        this.setState({ selectedStatement: null });
    }

    private customTableColumns(): DataTableColumnProps<StudentStatementDTO>[] {
        return [
            {
                columnProps: {
                    title: this.props.translate('admin.studentStatements.columnHeader2'),
                    dataIndex: 'isCompleted',
                    sorter: true,
                    render: (text, record) => (
                        <Checkbox
                            checked={record.userCompletion != null ? record.userCompletion.isCompleted : false}
                            onChange={() => this.updateStudentStatement(record.statementId, record.gradeId)}/>
                    ),
                },
                filterType: Filterer.BooleanCheckbox
            },
            DataTable.AdvancedColumns.Text(<Translate id="admin.studentStatements.columnHeader1" />, "statementText"),
            DataTable.AdvancedColumns.CustomLegacy("Notes", "userCompletion", 80, "DEFAULT", "Text", (text, record) => {
                if (record.userCompletion == null || record.userCompletion.statementNotes == null || record.userCompletion.statementNotes.length < 1) {
                    return null;
                }
                return "Yes";
            }),
            DataTable.AdvancedColumns.CustomLegacy("Files", "userCompletion", 80, "DEFAULT", "Text", (text, record) => {
                if (record.userCompletion == null || record.userCompletion.statementFiles == null || record.userCompletion.statementFiles.length === 0) {
                    return null;
                }
                return "Yes";
            }),
            {
                columnProps: {
                    key: 'view',
                    align: 'center',
                    width: 35,
                    render: (text, record, index) => {
                        return (
                            <Tooltip placement="bottom" title={"View Files"} arrowPointAtCenter>
                                <Button shape="circle" icon="profile" onClick={() => this.openNotesModal(record)} />
                            </Tooltip>
                        );
                    }
                }
            }
        ];
    }

    private handleRedirect(): void {
        let isAdminTable = false;

        let redirectUrl = this.state.classroomId ?
            Routes.getRoute(Routes.ADMIN_ADD_EDIT_CLASSROOM, this.state.classroomId) :
            Routes.getRoute(Routes.ADMIN_USERS, isAdminTable);

        this.props.history.push(redirectUrl);
    }

    render() {
        return (
            <div>
                <h2>{this.props.translate('admin.studentStatements.tableHeader')}</h2>

                <DataTable
                    ref={ref => this.dataTableRef = ref}
                    serverSide={true}
                    tableProps={{ rowKey: 'statementUserId', loading: this.state.loading }}
                    columns={this.customTableColumns()}
                    data={this.state.tableRecords}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButton('common.back', this.handleRedirect),
                        new DataTableButtonReset()
                    ]} />

                <ViewStatementModal
                    visible={this.state.selectedStatement != null}
                    statement={this.state.selectedStatement}
                    onClose={this.closeNotesModal}
                />
            </div>
        );
    }
}

export default withLocalize(StudentStatements as any) as any;



// WEBPACK FOOTER //
// ./src/pages/admin/StudentStatements.tsx